import script from "./KanbanCard.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanCard.vue?vue&type=script&setup=true&lang=js"

import "./KanbanCard.vue?vue&type=style&index=0&id=b0116532&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0116532"]])

export default __exports__